import React, { ReactNode, Component } from 'react';
import classnames from 'classnames';
import {
	DropTarget,
	DropTargetMonitor,
	DropTargetConnector,
	ConnectDropTarget,
} from 'react-dnd';

import { TreeNode } from '../tree-layer';
import { DragPayload, FILE_EXPLORER_DRAG_ID } from './tree-node-drag';

type RequiredProps = {
	node: TreeNode<undefined>;
	onDrop: (from: string) => void;
	onDropHoverIn?: () => void;
	onDropHoverOut?: () => void;
	children: ReactNode;
	className?: string;
	classWhenDragged?: string;
};

export type DragChildren = { isDragging: boolean };

type DropProps = {
	dropTarget: ConnectDropTarget;
	isDropHover: boolean;
};

class DropHandle extends Component<DropProps & RequiredProps> {
	_hoverDropTimeout: any;
	componentDidUpdate(prevProps: DropProps & RequiredProps) {
		const nextProps = this.props;
		const isHoverIn = prevProps.isDropHover === false && nextProps.isDropHover === true;
		const isHoverOut = prevProps.isDropHover === true && nextProps.isDropHover === false;

		if (isHoverIn && nextProps.onDropHoverIn) {
			nextProps.onDropHoverIn();
		}
		if (isHoverOut && nextProps.onDropHoverOut) {
			nextProps.onDropHoverOut();
		}
	}

	render() {
		const {
			dropTarget,
			isDropHover,
			children,
			className = 'drag-handle',
			classWhenDragged = 'dragging-handle',
		} = this.props;

		// ☣️ warning - dangerous syntax
		// import isFunction from 'is-function';
		// type childrenFunction = (props: DragChildren) => ReactNode;
		// const content = isFunction(children)
		// 	? (children as childrenFunction)({ isDragging })
		// 	: (children as ReactNode);
		const content = children as ReactNode;

		return dropTarget(
			<div className={classnames(className, { [classWhenDragged]: isDropHover })}>
				{content}
			</div>
		);
	}
}

//why isn't this working as a decorator?? does not work even as class decorator
export const DroppableTreeNode = DropTarget<RequiredProps, DropProps>(
	FILE_EXPLORER_DRAG_ID,
	//drop contract:
	{
		drop: (props: RequiredProps, monitor: DropTargetMonitor) => {
			if (monitor.didDrop()) return;

			const { onDrop } = props;

			const item = monitor.getItem() as DragPayload;

			onDrop(item.id);
		},
		canDrop: (props: RequiredProps, monitor: DropTargetMonitor) => {
			const item = monitor.getItem();

			return item.id !== props.node.id;
		},
	},

	// dropConnect
	(connect: DropTargetConnector, monitor: DropTargetMonitor): DropProps => {
		return {
			dropTarget: connect.dropTarget(),
			isDropHover: monitor.canDrop() && monitor.isOver({ shallow: true }),
		};
	}
)(DropHandle);
